import React from "react"
import { Grid, Button, Icon, Dropdown } from "semantic-ui-react"
import PropTypes from "prop-types"
import Info from "./Info"
import { DailyAnalyticsCard, DailyAnalyticsData } from "./DailyAnalyticsCard"
import Switch from "react-switch"
import bind from "bind-decorator"
import { withTranslation } from "react-i18next"

class DailyAnalyticsHolder extends React.Component {
  static computeAvgBill(data) {
    return parseInt((data.saleSum + data.saleUniversalSum) / data.quantity) || 0
  }

  isLoading() {
    const { today, yesterday } = this.props
    return today.isLoading > 0 || yesterday.isLoading > 0
  }

  @bind
  refreshDailyAnalytics() {
    const { onRefreshDaily } = this.props
    if (!this.isLoading()) {
      onRefreshDaily()
    }
  }

  @bind
  refreshDailyProductAnalytics() {
    const { onRefreshProductDaily, resultText } = this.props
    if (!this.isLoading()) {
      onRefreshProductDaily(resultText)
    }
  }

  render() {
    const { t } = this.props
    const { today, yesterday, items, resultText, pick } = this.props
    const tenge = ["тг.", "тг.", "тг."]
    const salesData = new DailyAnalyticsData(
      tenge,
      [t("client1"), t("client2"), t("client3")],
      today.saleAnalytics.saleSum + today.saleAnalytics.saleUniversalSum,
      today.saleAnalytics.quantity,
      yesterday.saleAnalytics.saleSum +
        yesterday.saleAnalytics.saleUniversalSum,
      yesterday.saleAnalytics.quantity,
    )
    const purchasesData = new DailyAnalyticsData(
      tenge,
      [t("order1"), t("order2"), t("order3")],
      today.purchaseAnalytics.sum,
      today.purchaseAnalytics.quantity,
      yesterday.purchaseAnalytics.sum,
      yesterday.purchaseAnalytics.quantity,
    )
    const profitData = new DailyAnalyticsData(
      tenge,
      [t("averageCheck"), t("averageCheck"), t("averageCheck")],
      today.profit,
      DailyAnalyticsHolder.computeAvgBill(today.saleAnalytics),
      yesterday.profit,
      DailyAnalyticsHolder.computeAvgBill(yesterday.saleAnalytics),
    )
    const isLoading = this.isLoading()
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column computer={5} tablet={12} mobile={16}>
              <div>
                <h1>
                  Аналитика{" "}
                  <span>
                    <Info
                      text={t(
                        "In this section you can observe information on purchases, sales and profits of a particular store or product",
                      )}
                    />
                  </span>
                </h1>
              </div>
            </Grid.Column>
            <Grid.Column computer={11} tablet={12} mobile={16}>
              <div style={{ float: "right" }}>
                <Switch
                  offColor="#36A2EB"
                  onColor="#21BA45"
                  offHandleColor="#FFF"
                  onHandleColor="#FFF"
                  checked={pick}
                  onChange={this.props.handlePick}
                  handleDiameter={10}
                  checkedIcon={
                    <b
                      style={{
                        color: "#FFF",
                        marginLeft: "5px",
                      }}
                    >
                      {t("product")}
                    </b>
                  }
                  uncheckedIcon={
                    <b
                      style={{
                        color: "#FFF",
                        marginLeft: "-36px",
                      }}
                    >
                      {t("store")}
                    </b>
                  }
                  height={20}
                  width={85}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column computer={5} tablet={12} mobile={16}>
              <h2>
                {t("dailyStatistic")}
                {resultText && pick && (
                  <Button
                    basic
                    icon
                    disabled={isLoading}
                    onClick={this.refreshDailyProductAnalytics}
                  >
                    <Icon name="refresh" link loading={isLoading} />
                  </Button>
                )}
                {!resultText && pick && (
                  <Button basic icon>
                    <Icon name="refresh" link loading={isLoading} />
                  </Button>
                )}
                {!resultText && !pick && (
                  <Button
                    basic
                    icon
                    disabled={isLoading}
                    onClick={this.refreshDailyAnalytics}
                  >
                    <Icon name="refresh" link loading={isLoading} />
                  </Button>
                )}
              </h2>
            </Grid.Column>
            {pick && (
              <Grid.Column computer={11} tablet={12} mobile={16}>
                <Dropdown
                  search
                  clearable
                  placeholder={t("enterProductName")}
                  options={items}
                  onSearchChange={this.props.handleChange}
                  onChange={this.props.handleSelect}
                  onFocus={this.props.hanldeFocus}
                  selection
                  noResultsMessage={null}
                  selectOnBlur={false}
                  selectOnNavigation={false}
                  style={{ width: "80%" }}
                  searchInput={{ autoFocus: true }}
                />
                <Button
                  color="green"
                  style={{ marginLeft: "15px", marginBottom: "10px" }}
                  onClick={this.props.handleClick}
                >
                  {t("find")}
                </Button>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row centered>
            <Grid.Column computer={5} tablet={8} mobile={16}>
              <DailyAnalyticsCard
                title="Закупки"
                data={purchasesData}
                isLoading={isLoading}
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={8} mobile={16}>
              <DailyAnalyticsCard
                title={t("sales")}
                data={salesData}
                isLoading={isLoading}
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={8} mobile={16}>
              <DailyAnalyticsCard
                title={t("profit")}
                data={profitData}
                isLoading={isLoading}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

DailyAnalyticsHolder.propTypes = {
  today: PropTypes.object,
  onRefreshDaily: PropTypes.func,
  yesterday: PropTypes.object,
}

export default withTranslation()(DailyAnalyticsHolder)
